import {
  ApplicationConfig,
  inject,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { routes } from './app.routes';
import { loadRuntimeConfig } from './load-runtime-config';
import {
  httpTranslateLoader,
  initializeTranslate,
} from './core/i18n/translate-loader';
import { initializeAuth } from './core/auth/initialize-auth';
import { AuthenticationService } from './core/services/authentification.service';
import { httpInterceptorProviders } from './core/interceptors';
import { registerFontAwesomeIcons } from './core/icons/register-fontawesome-icons';

/** Providers applicatifs : router, HTTP, i18n, auth, config runtime, icônes. */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      FontAwesomeModule,
      TranslateModule.forRoot({
        defaultLanguage: 'fr',
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    ...httpInterceptorProviders,
    provideAppInitializer(() => loadRuntimeConfig()()),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      return initializeTranslate(translate)();
    }),
    provideAppInitializer(() => {
      const auth = inject(AuthenticationService);
      return initializeAuth(auth)();
    }),
    provideAppInitializer(() => {
      registerFontAwesomeIcons(inject(FaIconLibrary));
    }),
  ],
};
